module.exports = {"Warn":"경고","Error":"오류","Critical":"심각","Ok":"정상"}


//////////////////
// WEBPACK FOOTER
// ./src/_fdp/core/i18n/bundle/message-ko.json
// module id = rF21
// module chunks = 20